(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mytouchi-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-mta]');
    if (!root) return;
    const items = root.querySelectorAll('[data-mta-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytouchi-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-mtc]');
    if (!root) return;
    const items = root.querySelectorAll('[data-mtc-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytouchi-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-mt-home]');
    if (!root) return;
    const revealItems = root.querySelectorAll('[data-mt-reveal]');
    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    revealItems.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(item);
    });
    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytouchi-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-mytouchi-page]');
    if (!root) return;
    const items = root.querySelectorAll('[data-mp-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytouchi-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-mytouchi-product-story]');
    if (!root) return;
    const items = root.querySelectorAll('[data-mps-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytouchi-studio"] && !Shopify.designMode) return;
  try {
    
function initMyTouchiStudio(scope) {
  scope.querySelectorAll('[data-mts]').forEach((root) => {
    if (root.dataset.mtsReady) return;
    root.dataset.mtsReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-mts-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-mts-panel]'));
    const activate = (selected, focus) => {
      tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.mtsPanel !== selected.dataset.mtsTab; });
      if (focus) selected.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (event) => {
        let index;
        if (event.key === 'ArrowRight') index = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') index = (i + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = tabs.length - 1;
        if (index !== undefined) { event.preventDefault(); activate(tabs[index], true); }
      });
    });
  });
}
initMyTouchiStudio(document);
document.addEventListener('shopify:section:load', (event) => initMyTouchiStudio(event.target));
function initMyTouchiFilms(scope){
 scope.querySelectorAll('[data-mts-cinema]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const tabs=[...root.querySelectorAll('[data-film-tab]')],panels=[...root.querySelectorAll('[data-film-panel]')];
  const activate=(tab,focus)=>{tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1});panels.forEach(p=>{p.hidden=p.dataset.filmPanel!==tab.dataset.filmTab;if(p.hidden)p.querySelector('video').pause()});if(focus)tab.focus()};
  tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab,false));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();activate(tabs[n],true)}})});
 });
}
initMyTouchiFilms(document);document.addEventListener('shopify:section:load',e=>initMyTouchiFilms(e.target));


  } catch(e) { console.error(e); }
})();
})();
